import { render, staticRenderFns } from "./BuyerInvoicesDash.vue?vue&type=template&id=50e9f940"
import script from "./BuyerInvoicesDash.vue?vue&type=script&lang=js"
export * from "./BuyerInvoicesDash.vue?vue&type=script&lang=js"
import style0 from "./BuyerInvoicesDash.vue?vue&type=style&index=0&id=50e9f940&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports